import { CAMPAIGN_SERVICE_IDS, SERVICE_IDS } from '@/constants/services'

export function normalizeServiceIds(services) {
  if (!Array.isArray(services)) {
    return []
  }

  return services
    .map((entry) => {
      if (typeof entry === 'number') {
        return entry
      }
      if (typeof entry === 'string' && entry !== '' && !Number.isNaN(Number(entry))) {
        return Number(entry)
      }
      if (entry && typeof entry === 'object') {
        const id = entry.service_id ?? entry.id
        return id != null ? Number(id) : null
      }
      return null
    })
    .filter((id) => Number.isInteger(id) && id > 0)
}

export function hasService(services, serviceId) {
  return normalizeServiceIds(services).includes(Number(serviceId))
}

export function hasAnyService(services, serviceIds) {
  const owned = new Set(normalizeServiceIds(services))
  return serviceIds.some((id) => owned.has(Number(id)))
}

export function hasCampaignService(services) {
  return hasAnyService(services, CAMPAIGN_SERVICE_IDS)
}

export function hasWhatsappOrChat(services) {
  return hasAnyService(services, [SERVICE_IDS.WHATSAPP, SERVICE_IDS.CHAT])
}

export function routeAllowsServices(routeMeta, services) {
  const required = routeMeta?.requiresServices
  if (!Array.isArray(required) || required.length === 0) {
    return true
  }

  if (routeMeta?.requiresAllServices) {
    const owned = new Set(normalizeServiceIds(services))
    return required.every((id) => owned.has(Number(id)))
  }

  return hasAnyService(services, required)
}
